<template>
    <div class="modal fade" id="setor_update_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Atualizar</b>
                        </h5>
                        <!-- <button type="button" class="close">
                            <span aria-hidden="true">×</span>
                        </button> -->
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            <div class="alert alert-danger" v-if="errors.length > 0">
                                <ul>
                                    <li v-for="error in errors">{{ error }}</li>
                                </ul>
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">Nome:</label>
                                <input type="text" v-model="update_setor.nome" class="form-control">
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">Resposável:</label>
                                <input type="text" placeholder="Nome do Responsável" v-model="update_setor.responsavel" class="form-control">
                            </div>

                            <div class="form-group">
                                <label class="col-form-label" for="title">Unidade:</label>
                                <basic-select :options="unidades"
                                        :selected-option="unidade"
                                        placeholder="Selecione a Unidade"
                                        @select="onSelectUnidade">
                                </basic-select>
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success"
                            @click.prevent.stop="updateSetor">
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';
    import { BasicSelect } from 'vue-search-select';

    export default {

    	components: {
            Dot,
            BasicSelect
        },


    	data(){
            return {
                currentPagePagination: null,

            	isLoading: false,

                //ARRAYS
            	errors: [],
                unidades: [],

                //OBJECTS
                unidade: {},
                update_setor: {},
                update_setor_old: {}
            }
        },

        mounted(){
        	this.registryEventOpenModalUpdateSetor();
        },

        methods: {
            registryEventOpenModalUpdateSetor(){
                eventBus.$on('eventOpenModalUpdateSetor', (updateSetor, currentPage) => {
                	this.errors = [];
                    this.currentPagePagination = currentPage;
                    $("#setor_update_modal").modal("show");
                    this.setDataSetor(updateSetor);
                    this.getUnidades();
                });
            },

            setDataSetor(setorParam){
                this.update_setor = Object.assign({}, setorParam);
                this.update_setor_old = Object.assign({}, setorParam);
                this.unidade = {
                    value: setorParam.unidade_id,
                    text: setorParam.unidade_nome
                };
            },

            emitEventGetSetores(){
                eventBus.$emit('eventGetSetores', this.currentPagePagination);
            },

            //OUTROS METODOS
            onSelectUnidade(item) {
                this.unidade = item;
                this.update_setor.unidade_id = this.unidade.value;
            },
            //FIM OUTROS METODOS

            checkForm:function(acao) {
                this.errors = [];

                if(this.update_setor.nome == this.update_setor_old.nome &&
                    this.update_setor.responsavel == this.update_setor_old.responsavel &&
                    this.update_setor.unidade_id == this.update_setor_old.unidade_id
                ) {
                    this.errors.push("Altere os dados");
                    return false;
                }

                if(this.update_setor.nome &&
                    this.update_setor.responsavel &&
                    this.update_setor.unidade_id
                ) {
                    return true;
                }
                
                if(!this.update_setor.nome) this.errors.push("Informe o nome");
                if(!this.update_setor.responsavel) this.errors.push("Informe o responsável");
                if(!this.update_setor.unidade_id) this.errors.push("Selecione a Unidade");
            },

            updateSetor()
            {
                if(this.checkForm()){
                    this.isLoading = true;
                    axios.put('/setor/' + this.update_setor.id, this.update_setor)
                    .then(response => {
                        this.isLoading = false;
                        $("#setor_update_modal").modal("hide");
                        toastr.success(response.data.message);
                        this.emitEventGetSetores();
                    })
                    .catch(error => {
                        let me = this;
                        this.isLoading = false;
                        let erroObject = error.response.data;
                        this.errors = [];
                        if( error.response.status === 422 ){
                            if (erroObject.errors) {
                                $.each(erroObject.errors, function (key, value) {
                                    me.errors.push(value[0]);
                                });
                            }
                        }
                        else {
                            toastr.error(erroObject.message);
                        }
                    });
                }
            },

            getUnidades(){

                var urlUnidades = '/unidade/combo';
                
                this.isLoading = true;
                
                axios({
                    method: 'GET',
                    url: urlUnidades
                })
                .then(response => {
                    let me = this;
                    this.isLoading = false;
                    this.unidades = [];
                    $.each(response.data, function (key, value) {
                        me.unidades.push({
                            'value': value.id,
                            'text': value.nome
                        });
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao listar unidades gestoras');
                });
            },
        }
    }
</script>